import React, { useState, useRef, useEffect } from 'react';
import moment from 'moment';

import { Wizard, NotificationList } from 'quanta-ui';

import Plans from './plans';
import Members from './members';
// import Loading from '../../../../../lib/layout/loading';
import { Loading } from 'quanta-flows/modules/layout';
import { Error } from 'quanta-flows/modules/layout';
// import Error from '../../../../../lib/layout/error';

//import { GET_PRODUCT_DETAILS, QUERY_STATE } from '../queries';
import { GET_PRODUCT_DETAILS,QUERY_STATE } from 'quanta-flows/modules/quote/health';
import {
  faUsers,
  faFileAlt,
  faMotorcycle
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { useFetchQuery } from '../../../../../exports';
import { useFetchQuery } from 'quanta-flows';
export default function QuoteWizard({
  productName,
  productCode,
  quoteNumber,
  lobCode,
}) {
  const startStep = quoteNumber ? 1 : 0;
  const fetchQuery = useFetchQuery();
  const [productDetails, setProductDetails] = useState(null);
  const [genderList, setGenderList] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  let errorMessage = `There was an issue fetching the Form. Please try again after some time...`;


  useEffect(() => {
    let isMounted = true;
    if (isMounted) {
      setError(null);
      setLoading(true);
      fetchQuery({
        query: QUERY_STATE,
      })
        ?.then((response) => {
          if (isMounted) {
            const { healthQuote, selectedIntermediary } =
              response?.data;
              //console.log('data----',response?.data)
            fetchQuery({
              query: GET_PRODUCT_DETAILS,
              variables: {
                input: {
                productCode,
                startDate: moment().format('DD/MM/YYYY').toString(),
                imdCode:
                  healthQuote?.intermediaryDetails?.code ||
                  selectedIntermediary?.intermediaryCode,
                },
              },
            })
              ?.then((response) => {
                ////console.log('response data index',response?.data)
                setLoading(false);
                setProductDetails(response?.data?.productDetails);
                setGenderList(response?.data?.genderList);
              })
              ?.catch((error) => {
                setLoading(false);
                setError(error?.message);
              });
          }
        })
        ?.catch((error) => {
          if (isMounted) {
            setLoading(false);
            setError(error?.message);
          }
        });
    }
    return () => {
      isMounted = false;
    };
  }, []);

  const [proceedToPlanPage, setProceedToPlanPage] = useState(false);
  const [alerts, setAlerts] = useState([]);
  const memberFormRef = useRef();

  if (loading) {
    return (
      <div className="h-screen">
        <Loading />
      </div>
    );
  }
  if (error) {
    return <Error error={errorMessage} />;
  }

  const steps = [
    {
      icon: <FontAwesomeIcon icon={faMotorcycle} />,
      label: 'Vehicle',
      proceedLabel: () => 'Show Available Plans',
      submitForm: async () => {
        if (memberFormRef.current) {
          const res = await memberFormRef.current.submitForm();
          return res;
        }
        return false;
      },
      stepCompleted: () => proceedToPlanPage,
      stepNotCompleteAlert: () => {
        if (memberFormRef?.current?.errors?.cover?.type) {
          setAlerts([
            {
              header: 'Warning',
              id: Date.now(),
              content: (
                <div className="flex flex-row flex-wrap space-y-2 w-full h-full">
                  <span>
                    {`${memberFormRef?.current?.errors?.cover?.type
                      ?.split('*')[1]
                      ?.trim()} for the selected cover type`}
                  </span>
                </div>
              ),
              type: 'warning',
              timeout: null,
              disableClose: false,
            },
          ]);
        } else {
          setAlerts([
            {
              header: 'Warning',
              id: Date.now(),
              content: (
                <div className="flex flex-row flex-wrap space-y-2 w-full h-full">
                  <span>
                    Please fill in all the mandatory fields to proceed
                  </span>
                </div>
              ),
              type: 'warning',
              timeout: null,
              disableClose: false,
            },
          ]);
        }
        window.scrollTo({ top: 0, behavior: 'smooth' });
      },
      component: ({ expanded }) =>
        expanded ? (
          <Members
            quoteNumber={quoteNumber}
            setProceedToPlanPage={setProceedToPlanPage}
            setAlerts={setAlerts}
            productDetails={productDetails}
            genderList={genderList}
            forwardedRef={memberFormRef}
            productCode={productCode}
            productName={productName}
            lobCode={lobCode}
          />
        ) : null,
    },
    {
      icon: <FontAwesomeIcon icon={faFileAlt} />,
      label: 'Plans',
      proceedLabel: () => undefined,
      stepNotCompleteAlert: () => undefined,
      component: ({ expanded, goToStep }) =>
        expanded ? (
          <Plans
            productName={productName}
            productCode={productCode}
            quoteNumber={quoteNumber}
            lobCode={lobCode}
            goToStep={goToStep}
            genderList={genderList}
          />
        ) : null,
    },
  ];

  return (
    <div className="min-h-full">
      {loading || !productDetails || !genderList ? (
        <div className="h-screen">
          <Loading />
        </div>
      ) : error ? (
        <Error error={errorMessage} />
      ) : (
        <Wizard
          {...{
            steps,
            startStep,
            tabStyle: true,
            switchTabs: false,
            buttonSize: 'medium',
          }}
        />
      )}
      <div>
        <NotificationList {...{ items: alerts }} />
      </div>
    </div>
  );
}
